import { Controller } from '@hotwired/stimulus';

export default class CertificateApplicationsCertificateType extends Controller {
  static targets = [
    'radio',
    'quantity',
    'submit'
  ];

  connect() {
    this.radioChecked();
  }

  radioChecked() {
    const radio = this.radioTargets.find(radio => radio.checked);

    for (const el of this.quantityTargets) {
      if (el.dataset.certificateTypeId === radio?.value) {
        el.disabled = false;
        this.submitTarget.disabled = el.value === '' || el.value < 1;
      } else {
        el.disabled = true;
        el.value    = '';
      }
    }
  }

  update(e) {
    this.submitTarget.disabled = e.target.value === '' || e.target.value < 1;
  }
}
